export default {
  LOAD_EMPLOYER (state, payload) {
    state.employer = payload
  },
  LOAD_REPORT (state, payload) {
    state.report = payload
  },
  LOAD_EMPLOYERS (state, payload) {
    state.employers = payload
  },
  LOAD_CATEGORIES (state, payload) {
    state.categories = payload
  },
  LOAD_JOBS (state, payload) {
    state.jobs = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/employer/vuex/mutations.js